import React from 'react';
const ComplainTicketConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/apps/complain/ticket',
			component: React.lazy(() => import('./index.js'))
		}
	]
};
export default ComplainTicketConfig;
